<template>
  <div class="rt-advance-table-group">
    <template v-if="labelList && labelList.length > 0">
      <rt-checkbox
        v-if="showCheckAll"
        v-model="checkAll"
        :indeterminate="isIndeterminate"
        class="rt-check-all"
        @change="handleCheckAllChange"
      >
        {{ $tx('全选', 'xpc.advancetable.checkall') }}
      </rt-checkbox>
      <el-checkbox-group
        v-if="showCheckAll"
        v-model="selectValue"
        v-bind="$attrs"
        :class="classes"
        @change="handelChange"
      >
        <slot
          v-for="(item, index) in dataList"
          :item="item"
          :index="index"
          name="collapse"
        ></slot>
        <slot v-if="!computedCollapse && !defaultRows">
          <rt-advance-table-item
            v-for="(item, index) in labelList"
            :key="index"
            :label="item[valueKey]"
            :show-check="showCheckAll"
          >
            {{ item[nameKey] }}
          </rt-advance-table-item>
        </slot>
      </el-checkbox-group>
      <div
        v-else
        :class="classes"
      >
        <slot
          v-for="(item, index) in dataList"
          :item="item"
          :index="index"
          name="collapse"
        ></slot>
        <slot v-if="!computedCollapse && !defaultRows">
          <rt-advance-table-item
            v-for="(item, index) in labelList"
            :key="index"
            :label="item[valueKey]"
            :show-check="false"
          >
            {{ item[nameKey] }}
          </rt-advance-table-item>
        </slot>
      </div>
      <rt-button-more
        v-if="computedCollapse"
        class="rt-xpc-advance-table-more"
        expanded-suffix-icon="rt-base-arrow-up-lined"
        collapsed-suffix-icon="rt-base-arrow-down-lined"
        @change="_changeExpand"
      ></rt-button-more>
    </template>
    <template v-else>
      <slot name="empty">
        <rt-default-image
          size="medium"
          text
        >
          <div slot="describe">
            {{ $tx('暂无数据', 'xpc.uploadfile.nodata') }}
          </div>
        </rt-default-image>
      </slot>
    </template>
  </div>
</template>
<script>
import RtAdvanceTableItem from '../table/rtAdvanceTableItem';
import RtDefaultImage from '../defaultImage/rtDefaultImage.vue';
import RtButtonMore from '../button/rtButtonMore.vue';
import RtCheckbox from '../checkbox/rtCheckbox.vue'

export default {
  name: 'RtAdvanceTableGroup',
  components: {
    RtAdvanceTableItem,
    RtDefaultImage,
    RtButtonMore,
    RtCheckbox
  },
  provide () {
    return {
      col: this.col
    };
  },
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showCheckAll: {
      type: Boolean,
      default: false
    },
    showCollapse: {
      type: Boolean,
      default: false
    },
    col: {
      type: Number,
      default: 1
    },
    defaultRows: Number
  },
  data () {
    return {
      selectValue: this.value,
      isIndeterminate: false,
      checkAll: false,
      packUp: false
    };
  },
  computed: {
    valueKey () {
      return this.alias.valueKey;
    },
    nameKey () {
      return this.alias.nameKey;
    },
    classes () {
      return [
        'rt-checkbox-group',
        {
          'rt-checkbox-group-vertical': this.vertical
        }
      ];
    },
    dataList () {
      if (this.computedCollapse && this.packUp) {
        return this.labelList;
      } else {
        return this.labelList.slice(0, this.defaultRows);
      }
    },
    computedCollapse () {
      return !!(this.showCollapse || (this.defaultRows && this.defaultRows < this.labelList.length));
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange () {
      let checkedCount = this.selectValue.length;
      this.checkAll = checkedCount === this.labelList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.labelList.length;
      this.$emit('input', this.selectValue);
    },
    handleCheckAllChange (value) {
      this.selectValue = value ? this.labelList.map(elem => elem[this.valueKey]) : [];
      this.isIndeterminate = false;
      this.$emit('input', this.selectValue);
    },

    /**
     * @private
     */
    _changeExpand (isExpand) {
      this.$emit(isExpand ? 'roll-up' : 'pack-up');
      this.packUp = isExpand;
    },

    /**
     * @deprecated
     */
    packUpItems () {
      this._changeExpand(false);
    },
    /**
     * @deprecated
     */
    rollUpItems () {
      this._changeExpand(true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAdvanceTableGroup.vue?245c965f